import './App.css';
import { useState, useEffect, createContext } from 'react';

import TreeList from './components/TreeList';
import Header from './components/Header';

import TaskNode from './models/TaskNode'
import ItemClass from './models/ItemClass';

import generateUUID from './util/UUIDUtils';

// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics, setUserId } from "firebase/analytics";

import LandingPage from './components/LandingPage/LandingPage';

export const DbContext = createContext()
export const SortableContext = createContext()

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCtz_2oLt0bjtAIKELRRF7uTQBhCDF-qdk",
  authDomain: "tasktodo-7418e.firebaseapp.com",
  databaseURL: "https://tasktodo-7418e-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "tasktodo-7418e",
  storageBucket: "tasktodo-7418e.appspot.com",
  messagingSenderId: "700764488352",
  appId: "1:700764488352:web:826b60059ee42dd7f27fc5",
  measurementId: "G-SED1K78NB5"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);


function App() {

  const root = new TaskNode(new ItemClass(420, null, "Write something"));
  const [taskRoot, setTaskTreeRoot] = useState(root)
  const [db, setDb] = useState(null)


  function addToTree(nodeMap) {
    // 2️⃣ Then link parent-child relationships

    for (let [key,task] of nodeMap) {


      const node = nodeMap.get(task.value.id);
      const parentId = task.value.parentId ?? "root";
      const parent = nodeMap.get(parentId);

      // console.log("node", node)
      // console.log("parent", parent)

      if (parent) {
        parent.addChild(node);
      }

    }
  
  }

  function sortTree(node) {

    if (node.value === undefined)
      return;
  
    if(node.children.length === 0)
      return;
  
    node.children.sort((a, b) => { return a.value.sortOrder - b.value.sortOrder} )
  
    for(let i = 0; i < node.children.length; i++) {
      sortTree(node.children[i])
    }
  
  }

  const getDataFromDb = () => {

    let tasksObjectStore;

    const request = window.indexedDB.open("list-db", 1);

    request.onsuccess = (event) => {
      const db = event.target.result;

      setDb(db)
    
      tasksObjectStore = db
          .transaction("tasks", "readonly")
          .objectStore("tasks");

      // Map of all nodes by ID (for quick lookup)
      const nodeMap = new Map();

      // Root node (your tree’s invisible container)
      nodeMap.set('root', root);

    
      tasksObjectStore.index("dateAdded").openCursor().onsuccess = (event) => {

        const cursor = event.target.result;
        if (cursor) {

          const task = cursor.value;
          // console.log("task", task)
          nodeMap.set(task.id, new TaskNode(task));
          cursor.continue();
        }
        else {

          addToTree(nodeMap);
          // console.log("root", nodeMap.get('root') );
          setTaskTreeRoot({...nodeMap.get('root')})
          sortTree(root)
        }
      }
    
    
      tasksObjectStore.transaction.oncomplete = (event) => {
        console.log("object store created");
      }
    
      tasksObjectStore.transaction.onerror = (event) => {
        console.log(event.target.error.message);
      }
    }


    request.onupgradeneeded = (event) => {
      console.log("onupgradeneeded");

      const db = event.target.result;

      const objectStore = db.createObjectStore("tasks", { keyPath: "id", autoIncrement: true });

      objectStore.createIndex("id", "id", { unique: true });
      objectStore.createIndex("parentId", "parentId", { unique: false })
      objectStore.createIndex("data", "data", { unique: false });
      objectStore.createIndex("dateAdded", "dateAdded", { unique: true });
    
      objectStore.transaction.oncomplete = (event) => {
        console.log("object store created");
      }
    
      objectStore.onerror = (event) => {
        console.log("object store creation failed");
      }

      const projectStore = db.createObjectStore("projects", { keyPath: "id", autoIncrement: true });

    }
    
    request.onerror = (event) => {
      console.log("onerror");
    }
  }

  useEffect(() => {
    getDataFromDb()
  }, [])

  function onChange(task) {

    const newTaskRoot = new TaskNode(taskRoot.value, taskRoot.children)

    newTaskRoot.addChild(new TaskNode(task))
    setTaskTreeRoot(newTaskRoot)
  }

  function refresh() {

    const refreshedRoot = new TaskNode(new ItemClass(420, null, "Write something"));

    // Map of all nodes by ID (for quick lookup)
    const nodeMap = new Map();

    nodeMap.set('root', refreshedRoot);

    const tasksObjectStore = db
        .transaction("tasks", "readonly")
        .objectStore("tasks");


    tasksObjectStore.index("dateAdded").openCursor().onsuccess = (event) => {

      const cursor = event.target.result;

      if (cursor) {

        const task = cursor.value;
        nodeMap.set(task.id, new TaskNode(task))
        cursor.continue();
      }
      else {

        addToTree(nodeMap)
        setTaskTreeRoot({...nodeMap.get("root")});
        sortTree(refreshedRoot)
        console.log("refreshed root :", refreshedRoot)
        setTaskTreeRoot({...refreshedRoot})
      }
    }
  }

  const [isLoggedIn, setIsLoggedIn] = useState(false)


  const [active, setActive] = useState(null)
  const [over, setOver] = useState(null)
  const [position, setPosition] = useState(null)

  function onDragStart() {
    console.log("onDragStart")

    setActive(null)
    setOver(null)
    setPosition(null)
  }

  function onDragOver(data) {
    // console.log("onDragOver", data)

    setActive(data.active)
    setOver(data.over)
    setPosition(data.position)

  }

  function getAllItems(db) {
    return new Promise((resolve, reject) => {
      const tx = db.transaction("tasks", "readonly");
      const req = tx.objectStore("tasks").getAll();
      req.onsuccess = () => resolve(req.result);
      req.onerror  = () => reject(req.error);
    });
  }

  function putItem(store, item) {
    return new Promise((resolve, reject) => {
      const req = store.put(item);
      req.onsuccess = () => resolve();
      req.onerror   = () => reject(req.error);
    });
  }

  async function onDragEnd() {
    console.log("onDragEnd START", { active, over, position });
    if (!active || !over || active === over || !db) {
      console.warn("onDragEnd EARLY EXIT", { active, over, activeEqualsOver: active === over, dbExists: !!db });
      return;
    }
  
    try {
      console.log("📋 Fetching all items from DB...");
      const allItems = await getAllItems(db);
      console.log(`✅ Fetched ${allItems.length} total items`, allItems);
  
      const activeItem = allItems.find(i => i.id === active);
      const overItem = allItems.find(i => i.id === over);
  
      console.log("🎯 Found active & over items:", {
        activeItem: activeItem ? { id: activeItem.id, parentId: activeItem.parentId, data: activeItem.data, sortOrder: activeItem.sortOrder } : null,
        overItem: overItem ? { id: overItem.id, parentId: overItem.parentId, data: overItem.data, sortOrder: overItem.sortOrder } : null,
      });
  
      if (!activeItem || !overItem) {
        console.error("❌ Missing activeItem or overItem, bailing out", { activeFound: !!activeItem, overFound: !!overItem });
        return;
      }
  
      // // Never drop a node into its own subtree
      // if (isDescendant(allItems, over, active)) return;
  
      console.log("🔄 Creating IDB transaction (readwrite)...");
      const tx = db.transaction("tasks", "readwrite");
      const store = tx.objectStore("tasks");
  
      // ✅ Register BEFORE any await — can't miss the event
      const txComplete = new Promise((resolve, reject) => {
        tx.oncomplete = () => {
          console.log("✅ Transaction COMPLETED successfully");
          resolve();
        };
        tx.onerror = () => {
          console.error("❌ Transaction ERROR:", tx.error);
          reject(tx.error);
        };
        tx.onabort = () => {
          console.error("❌ Transaction ABORTED");
          reject(tx.error);
        };
      });
  
      if (position === "child") {
        // ── Append as last child of 'over' ────────────────────────────────
        console.log(`📂 position=child: Appending active (${active}) as child of over (${over})`);
  
        const overChildren = allItems
          .filter(i => i.id !== active && i.parentId === over)
          .sort((a, b) => a.sortOrder - b.sortOrder);
  
        console.log(`  Found ${overChildren.length} existing children of ${over}:`, overChildren.map(c => ({ id: c.id, sortOrder: c.sortOrder })));
  
        activeItem.parentId = over;
        activeItem.sortOrder = overChildren.length ? overChildren.at(-1).sortOrder + 1 : 0;
  
        console.log(`  Setting activeItem: parentId=${activeItem.parentId}, sortOrder=${activeItem.sortOrder}`);
        console.log(`  Calling putItem for activeItem (${activeItem.id})...`);
  
        await putItem(store, activeItem);
  
        console.log(`  ✅ putItem done for activeItem`);
      } else {
        // ── Reorder among over's siblings (top = before, bottom = after) ────
        console.log(`↕️ position=${position}: Reordering active (${active}) relative to over (${over})`);
  
        activeItem.parentId = overItem.parentId;
        console.log(`  Set activeItem.parentId = ${activeItem.parentId}`);
  
        const siblings = allItems
          .filter(i => i.id !== active && i.parentId === overItem.parentId)
          .sort((a, b) => a.sortOrder - b.sortOrder);
  
        console.log(`  Found ${siblings.length} siblings with parentId=${overItem.parentId}:`, siblings.map(s => ({ id: s.id, sortOrder: s.sortOrder })));
  
        const overIndex = siblings.findIndex(i => i.id === over);
        console.log(`  overIndex (position of 'over' in siblings): ${overIndex}`);
  
        const insertAt = position === "top" ? overIndex : overIndex + 1;
        console.log(`  Inserting activeItem at index ${insertAt} (position=${position})`);
  
        siblings.splice(insertAt, 0, activeItem);
  
        console.log(`  After splice, siblings order:`, siblings.map((s, idx) => ({ idx, id: s.id, oldSort: s.sortOrder })));
  
        // Re-index all siblings with clean 0-based sortOrder
        console.log(`  Re-indexing ${siblings.length} siblings with 0-based sortOrder...`);
        await Promise.all(
          siblings.map((item, idx) => {
            const oldSort = item.sortOrder;
            item.sortOrder = idx;
            console.log(`    Updating item ${item.id}: sortOrder ${oldSort} → ${idx}`);
            return putItem(store, item);
          })
        );
  
        console.log(`  ✅ All siblings updated`);
      }
  
      console.log("⏳ Waiting for transaction to complete...");
      await txComplete; // now safe
  
      console.log("🔄 Transaction complete, calling refresh()...");
      // Re-read DB → rebuild tree → re-render
      refresh();
  
      console.log("✅ onDragEnd COMPLETED successfully");
    } catch (err) {
      console.error("❌ onDragEnd FAILED:", err);
      console.error("Stack trace:", err.stack);
    }
  }

  if (isLoggedIn) {
    return (
      <div className='main'>
        <Header/>

        <DbContext.Provider value = {{db: db, onChange: onChange}}>
          <SortableContext.Provider value = {{onDragStart: onDragStart, onDragOver: onDragOver, onDragEnd: onDragEnd}}>
            <TreeList 
              data = {taskRoot} 
              onDelete={(taskId) => {
                const updatedChildren = taskRoot.children.filter((value) => value.value.id !== taskId )
                setTaskTreeRoot(new TaskNode(taskRoot.value, updatedChildren))
              }}
              onRefresh={refresh}
            />
          </SortableContext.Provider>
        </DbContext.Provider>
      </div>
    );
  }
  else {
    return <LandingPage onSignInButtonClicked={() => setIsLoggedIn(true)}></LandingPage>;
  }

}




export default App;
